import { type IIcon } from '@/app/types/iconType'

export const Edit = (props: Omit<IIcon, 'iconName'>) => {
    const { height = '40', width = '40', color = '#007DEE' } = props
    return (
        <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <rect width={width} height={height} rx='8' fill={color} fillOpacity='0.15' />
            <path
                d='M12.5 24.375V27.5H15.625L24.8417 18.2833L21.7167 15.1583L12.5 24.375ZM27.2583 15.8667C27.5833 15.5417 27.5833 15.0167 27.2583 14.6917L25.3083 12.7417C24.9833 12.4167 24.4583 12.4167 24.1333 12.7417L22.6083 14.2667L25.7333 17.3917L27.2583 15.8667Z'
                fill={color}
            />
        </svg>
    )
}
